<template>
  <div class="sidebar">
    <li v-for="item in content"
			class="flex project justify-between p-4"
			@click="selectItem(item)"
			:key="item.id"
			:class="{
				selected: selectedItem && selectedItem.id === item.id,
			}"
		>
			<p class="project__title">
				{{ item.name }}
				<sup class="project__type">{{ item.category }}</sup>
			</p>
			<div
				class="ml-2 arrow"
				:class="{
					arrow__blue:
						selectedItem && selectedItem.id === item.id,
				}"
			/>
		</li>
    
  </div>
</template>

<script>
export default {
  name: "Project",

  props: {
    content: {
      type: Array,
      required: false,
    },
		selectedItem: {
      type: null,
      required: false,
    },
  },
  methods: {
    selectItem(item) {
      this.$emit("click:item", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.arrow {
  &:hover {
    cursor: pointer;
  }
}
</style>
